import { render, staticRenderFns } from "./InvoicesHistory.vue?vue&type=template&id=e08fc34c&scoped=true&"
import script from "./InvoicesHistory.vue?vue&type=script&lang=js&"
export * from "./InvoicesHistory.vue?vue&type=script&lang=js&"
import style0 from "./InvoicesHistory.vue?vue&type=style&index=0&id=e08fc34c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08fc34c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VIcon,VSimpleTable})
